module.exports = __webpack_public_path__ + "static/media/roble_varenna.246aa97f.jpg";